import { Box } from '@mentimeter/ragnar-ui/box';
import { Image } from '@mentimeter/ragnar-ui/image';
import { useTranslations } from '@mentimeter/i18n';
import {
  BillingCycleSuccessSummary,
  getFormattedPlanName,
  LicensesSuccessSummary,
  PlansSuccessSummary,
} from '@mentimeter/checkout-ui';
import { PlanCategory } from '@mentimeter/http-clients';
import type { CheckoutModalType } from '../types';

interface CheckoutSuccessStateProps {
  type: CheckoutModalType;
  plan: PlanCategory;
  selectedLicenses: number;
  handleCloseModal: () => void;
  invoiceUrl: string;
  newPlanCycle?: string | undefined;
}

export const CheckoutSuccessState = ({
  type,
  plan,
  selectedLicenses,
  handleCloseModal,
  invoiceUrl,
  newPlanCycle,
}: CheckoutSuccessStateProps) => {
  const t = useTranslations('checkoutModalPackage');

  return (
    <Box
      flexDirection={['column', 'column', 'row']}
      width="100%"
      alignItems="stretch"
    >
      <Box flex="1 1 auto">
        <Box
          bg="#b5cce7"
          width="100%"
          height="100%"
          justifyContent="center"
          alignItems="center"
        >
          <Image
            src="https://static.mentimeter.com/static/images/using-mentimeter-confetti.svg"
            alt="success state"
          />
        </Box>
      </Box>
      <Box
        width={['100%', '100%', 405]}
        py="space18"
        px={['space8', 'space10']}
        bg="secondaryWeakest"
        alignItems={['center', 'center', 'unset']}
      >
        <>
          {type === 'licenses' && (
            <LicensesSuccessSummary
              invoiceUrl={invoiceUrl}
              addedLicenses={selectedLicenses}
              handleCloseModal={handleCloseModal}
            />
          )}
          {type === 'billing-cycle' && (
            <BillingCycleSuccessSummary
              invoiceUrl={invoiceUrl}
              billingCycle={newPlanCycle ?? 'yearly'}
            />
          )}
          {type === 'plan' && (
            <PlansSuccessSummary
              heading={t('success_title', {
                plan: getFormattedPlanName(plan, true),
              })}
              text={
                plan === PlanCategory.PRO ||
                plan === PlanCategory.EDUCATIONAL_PRO
                  ? t('success_text_pro')
                  : t('success_text_basic')
              }
              invoiceUrl={invoiceUrl}
            />
          )}
        </>
      </Box>
    </Box>
  );
};
